/* Publish by EComposer at 2026-10-01 15:36:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jn2k9bh0xz"]=  window.__ectimmers["ecom-jn2k9bh0xz"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-jn2k9bh0xz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jn2k9bh0xz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6e213nxg2kg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6e213nxg2kg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilnoa3p15dr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilnoa3p15dr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t150gmtn73e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t150gmtn73e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxt39f2lc4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxt39f2lc4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09pjna81nzjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09pjna81nzjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fhj10uw2je7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fhj10uw2je7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1k24lyra46z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1k24lyra46z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvhcol7h8rg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvhcol7h8rg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nmqkrq160jm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nmqkrq160jm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hpinrsxnfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hpinrsxnfh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2vn0q1cr9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2vn0q1cr9f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k7ssh5m6lsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k7ssh5m6lsb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rqtyxc3q3hk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqtyxc3q3hk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hyxesrve3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hyxesrve3n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjgkmnp5od8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjgkmnp5od8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bm4ih2udbse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bm4ih2udbse', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uapq2lkm4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uapq2lkm4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ku88wu482p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku88wu482p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvuk2ir8qfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvuk2ir8qfh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rjq9b2a4ki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rjq9b2a4ki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8mxnbwekm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8mxnbwekm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94k9gq39td8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94k9gq39td8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ocn7chwqt17').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ocn7chwqt17', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-155m688cy67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-155m688cy67', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qma5ijott3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qma5ijott3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8mchw2apg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8mchw2apg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zlswduxylnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zlswduxylnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lgklxumzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lgklxumzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgc6nqs1oza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgc6nqs1oza', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wk3vm6txrim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wk3vm6txrim', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p2ibwpvuxz"]=  window.__ectimmers["ecom-p2ibwpvuxz"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-p2ibwpvuxz"]["4ztrpbikf"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-p2ibwpvuxz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2ibwpvuxz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ixd6xqiop2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixd6xqiop2g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b673eovo0wo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b673eovo0wo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mcpgzrm3g1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mcpgzrm3g1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbnjx43del9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbnjx43del9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acf2pcpiv5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acf2pcpiv5d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvjfij24on').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvjfij24on', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yka6cj1g53r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yka6cj1g53r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5l0ofxnb5fc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5l0ofxnb5fc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gk40jy18gjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gk40jy18gjv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y68ryo541pf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y68ryo541pf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ng8a9vv4v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ng8a9vv4v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rnpihg3glw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rnpihg3glw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-smrgxmn4s8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smrgxmn4s8e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf0geo6lqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf0geo6lqj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pkb4sm39gn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pkb4sm39gn8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3l9lhk1n3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3l9lhk1n3q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulkgx2lexq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulkgx2lexq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ig450wr4wr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ig450wr4wr9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv8vcknkq1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv8vcknkq1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcgqoghfdp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcgqoghfdp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ts8f751z13m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ts8f751z13m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzaqs805dko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzaqs805dko', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6wnc8cmy224"]=  window.__ectimmers["ecom-6wnc8cmy224"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-6wnc8cmy224').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wnc8cmy224', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nzrptnlb6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nzrptnlb6c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ahopt9t8gb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ahopt9t8gb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mbldu3i0vn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mbldu3i0vn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3bafa5k27l6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3bafa5k27l6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qlxalhc8m8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qlxalhc8m8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iiean5wn4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iiean5wn4e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q08ip2jtwmd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q08ip2jtwmd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xf8d99pi1sj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xf8d99pi1sj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hkj0ypym94').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hkj0ypym94', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wnhx933iodr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wnhx933iodr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0g6bhyqk8dvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0g6bhyqk8dvp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wfilm7ehj7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wfilm7ehj7c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jn7otwftmsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jn7otwftmsb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lo9gzj0t50g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lo9gzj0t50g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itadqxxy2rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itadqxxy2rq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dzkno4jpzd5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dzkno4jpzd5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8twk2gqsa5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8twk2gqsa5g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q9mh74fznod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9mh74fznod', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}